/* eslint-disable no-useless-escape */
export const emailValidator = /^\w+([\+\.-]*\w+)*@\w+([\.-]?\w+)*(\.\w{2,30})+$/;
export const codeValidator = /^[0-9]{6,6}$/;
export const codeTypingValidator = /^[0-9]{0,6}$/;
export const priorityTagsValidator = /^[а-яА-Яa-zA-Z]{0,25}$/;
export const validLink = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
export const linkedInLinkValidator = /^(https?:\/\/)?(www\.)?(linkedin\.com\/)([\S]{1,100})$/mi;
export const facebookLinkValidator = /^(https?:\/\/)?(www\.)?(facebook\.com\/|fb\.me\/)([\S]{1,100})$/mi;
